import { useState, useCallback, useRef, Dispatch, SetStateAction, RefObject } from "react";

export function useStateRef<S>(initialState: S | (() => S)): [S, Dispatch<SetStateAction<S>>, RefObject<S>];

// convenience overload when first argument is omitted
export function useStateRef<S = undefined>(): [
	S | undefined,
	Dispatch<SetStateAction<S | undefined>>,
	RefObject<S | undefined>
];

/**
 * Passing state into nested functions can result in stale data.
 * Using useRef, we can always call .current to ensure we have the latest data.
 * @param defaultValue
 */
export function useStateRef(defaultValue?: any) {
	const [state, setState] = useState(defaultValue);
	const ref = useRef(state);

	const dispatch = useCallback(function (val) {
		ref.current = typeof val === "function" ? val(ref.current) : val;
		setState(ref.current);
	}, []);

	return [state, dispatch, ref];
}
